export const ITEMS_PER_PAGE = 30

export const itemSorts = {
  RECOMMENDED: { key: 'recommended', name: 'おすすめ順' },
  NEW_ARRIVAL: { key: 'new_arrival', name: '新着順' },
  PRICE_ASC: { key: 'price_asc', name: '価格が低い順' },
  PRICE_DESC: { key: 'price_desc', name: '価格が高い順' }
}

export const itemSortOptions = Object.values(itemSorts).map(
  ({ key, name }) => ({
    value: key,
    key: name
  })
)
